import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/';

class EstimatasiTransaksi {
  indexV3(type){
    return Axios.get(API_URL_V3 + `data/estimated-transaction-values?order_column=code&order_direction=asc&type=${type}`, { headers: header() });
  }

  showV3(masiTransaksiId) {
    return Axios.get(API_URL + `data/estimated-transaction-values/${masiTransaksiId}`);
  }
}

export default new EstimatasiTransaksi();



// WEBPACK FOOTER //
// ./src/api/estimasitransaksi.js